export default "__VITE_ASSET__306ef9c5__"